const state = {
    tablesStates: {},
    defaultTableStates: {}
}

const getters = {
    getStateForTable: (state) => (identifier) => {
        return state.tablesStates[identifier]
    },
    getDefaultStateForTable: (state) => (identifier) => {
        return state.defaultTableStates[identifier]
    }
};

const actions = {

    persistTableState({commit}, data) {
        commit('didPersistTableState', data)
    },

    initTableState({commit}) {
        commit('initTableStateMut')
    },

    setFilterTable({commit}, filterObject) {
        commit('setFilterTableMut', filterObject)
    },

    setDefaultFilterTable({commit}, filterObject) {
        commit('setDefaultFilterTableMut', filterObject)
    }

}

const mutations = {

    didPersistTableState(state, data) {
        state.tablesStates[data.identifier] = data
    },

    initTableStateMut(state) {
        state.tablesStates.B122TableIntervention = {...state.defaultTableStates.B122TableIntervention}
    },

    setFilterTableMut(state, filtersObject) {
        state.tablesStates[filtersObject.tableName].filters = filtersObject.filters
    },

    setDefaultFilterTableMut(state, filtersObject) {
        state.defaultTableStates[filtersObject.tableName] = filtersObject.filters
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/b122Table.js